import { Type } from '@sinclair/typebox';
export const SortOrderSchema = Type.Union([Type.Literal('asc'), Type.Literal('desc')], {
    default: 'desc',
});
//# sourceMappingURL=sort-order.js.map